<template>
  <v-card
    :style="`height: ${height}; overflow:auto;`"
    :outlined="outlined"
    :flat="!outlined"
  >
    <div :class="{ 'ma-3': outlined }">
      <slot></slot>
    </div>
  </v-card>
</template>

<script>
export default {
  props: {
    height: {
      default: "80vh",
      type: String
    },
    outlined: {
      default: true,
      type: Boolean
    }
  }
};
</script>

<style></style>
